import React, { useEffect, useState } from 'react';

const InstallPWA = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [esIOS, setEsIOS] = useState(false);
  const [mostrarIOS, setMostrarIOS] = useState(false);

  useEffect(() => {
    // Registrar service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => {});
    }

    // Detectar iOS
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    const isInStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;

    if (isIOS && !isInStandalone) {
      const dismissed = localStorage.getItem('pwa_ios_dismissed');
      if (!dismissed) {
        setEsIOS(true);
        setMostrarIOS(true);
      }
      return;
    }

    // Android / Chrome / Desktop
    const handler = e => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = localStorage.getItem('pwa_dismissed');
      const lastDismiss = parseInt(dismissed || '0');
      // Mostrar si nunca rechazó o hace más de 7 días
      if (!dismissed || Date.now() - lastDismiss > 7 * 24 * 60 * 60 * 1000) {
        setMostrar(true);
      }
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    setDeferredPrompt(null);
    setMostrar(false);
    if (outcome === 'dismissed') {
      localStorage.setItem('pwa_dismissed', Date.now().toString());
    }
  };

  const cerrar = () => {
    setMostrar(false);
    setMostrarIOS(false);
    localStorage.setItem(esIOS ? 'pwa_ios_dismissed' : 'pwa_dismissed', Date.now().toString());
  };

  const estiloBase = {
    position: 'fixed',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    zIndex: 99999,
    background: '#0f172a',
    border: '1px solid #00f2ff',
    borderRadius: '16px',
    padding: '16px 20px',
    boxShadow: '0 0 30px rgba(0,242,255,0.2)',
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    maxWidth: '90vw',
    width: '360px',
    animation: 'slideUp 0.3s ease',
  };

  if (mostrar && deferredPrompt) return (
    <>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateX(-50%) translateY(20px); } to { opacity:1; transform:translateX(-50%) translateY(0); } }`}</style>
      <div style={estiloBase}>
        <div style={{ fontSize: '2rem' }}>📲</div>
        <div style={{ flex: 1 }}>
          <p style={{ color: '#fff', fontWeight: 'bold', fontSize: '0.92rem', margin: '0 0 3px' }}>Instalar DTXI</p>
          <p style={{ color: '#64748b', fontSize: '0.75rem', margin: 0 }}>Agregá la app a tu pantalla de inicio</p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
          <button onClick={instalar}
            style={{ background: '#00f2ff', color: '#000', border: 'none', borderRadius: '8px', padding: '7px 14px', fontWeight: 'bold', fontSize: '0.8rem', cursor: 'pointer', whiteSpace: 'nowrap' }}>
            Instalar
          </button>
          <button onClick={cerrar}
            style={{ background: 'transparent', color: '#475569', border: 'none', fontSize: '0.72rem', cursor: 'pointer', padding: '2px' }}>
            Ahora no
          </button>
        </div>
      </div>
    </>
  );

  if (mostrarIOS && esIOS) return (
    <>
      <style>{`@keyframes slideUp { from { opacity:0; transform:translateX(-50%) translateY(20px); } to { opacity:1; transform:translateX(-50%) translateY(0); } }`}</style>
      <div style={estiloBase}>
        <div style={{ fontSize: '2rem' }}>📲</div>
        <div style={{ flex: 1 }}>
          <p style={{ color: '#fff', fontWeight: 'bold', fontSize: '0.88rem', margin: '0 0 4px' }}>Instalar DTXI en iPhone</p>
          <p style={{ color: '#94a3b8', fontSize: '0.74rem', margin: 0, lineHeight: 1.4 }}>
            Tocá <strong style={{ color: '#00f2ff' }}>Compartir</strong> y luego <strong style={{ color: '#00f2ff' }}>"Agregar a inicio"</strong>
          </p>
        </div>
        <button onClick={cerrar}
          style={{ background: 'transparent', border: '1px solid #1e293b', color: '#475569', borderRadius: '8px', padding: '6px 10px', fontSize: '0.75rem', cursor: 'pointer' }}>
          Cerrar
        </button>
      </div>
    </>
  );

  return null;
};

export default InstallPWA;